import { IconComponent } from '@backstage/core-plugin-api';
import { SIPCentralWhiteIcon } from './assets/icons';

export * from '../src/models/types';
export { SipCentralPage, sipCentralPlugin } from './plugin';
export const SIPCentralIcon: IconComponent = SIPCentralWhiteIcon;
